// src/components/Layout.js
import React, { useState } from 'react';
import { Outlet, NavLink, useLocation } from 'react-router-dom';
import Icon from './Icon';

const PAGE_TITLES = {
  '/':                       'Dashboard',
  '/transfers':              'File Transfers',
  '/upload':                 'New File Transfer',
  '/credentials':            'Credential Transfers',
  '/credentials/new':        'New Credential Transfer',
  '/filerequests':            'File Requests',
  '/credentialrequests':      'Credential Requests',
  '/filerequests/new':        'New File Request',
  '/credentialrequests/new':  'New Credential Request',
  '/admin/files':            'Manage File Transfers',
  '/admin/credentials':      'Manage Credential Transfers',
  '/admin/email-templates':  'Email Templates',
  '/admin/page-templates':   'Page Templates',
};

export default function Layout({ isAdmin, user, onLogout }) {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const pageTitle = PAGE_TITLES[location.pathname] || 'SUFC STS';
  const initials = user?.name ? user.name.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase() : '?';

  const closeMenu = () => setMenuOpen(false);

  const NavItems = () => (
    <>
      <NavLink to="/" end className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`} onClick={closeMenu}>
        <span className="sidebar-link-icon">🏠</span> Dashboard
      </NavLink>

      <div className="sidebar-section-label" style={{ marginTop: '8px' }}>Files</div>
      <NavLink to="/transfers" className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`} onClick={closeMenu}>
        <span className="sidebar-link-icon">📂</span> Send Files
      </NavLink>
      <NavLink to="/filerequests" className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`} onClick={closeMenu}>
        <span className="sidebar-link-icon">📥</span> Request Files
      </NavLink>

      <div className="sidebar-section-label" style={{ marginTop: '8px' }}>Credentials</div>
      <NavLink to="/credentials" className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`} onClick={closeMenu}>
        <span className="sidebar-link-icon">🔏</span> Send Credentials
      </NavLink>
      <NavLink to="/credentialrequests" className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`} onClick={closeMenu}>
        <span className="sidebar-link-icon">🔓</span> Request Credentials
      </NavLink>
      {isAdmin && (
        <>
          <div className="sidebar-section-label" style={{ marginTop: '8px' }}>Admin</div>
          <NavLink to="/admin/files" className={({ isActive }) => `sidebar-link admin${isActive ? ' active' : ''}`} onClick={closeMenu}>
            <span className="sidebar-link-icon">🗂</span> Manage Files
          </NavLink>
          <NavLink to="/admin/credentials" className={({ isActive }) => `sidebar-link admin${isActive ? ' active' : ''}`} onClick={closeMenu}>
            <span className="sidebar-link-icon">🛡</span> Manage Credentials
          </NavLink>
          <NavLink to="/admin/email-templates" className={({ isActive }) => `sidebar-link admin${isActive ? ' active' : ''}`} onClick={closeMenu}>
            <span className="sidebar-link-icon">📧</span> Email Templates
          </NavLink>
          <NavLink to="/admin/page-templates" className={({ isActive }) => `sidebar-link admin${isActive ? ' active' : ''}`} onClick={closeMenu}>
            <span className="sidebar-link-icon">📝</span> Page Templates
          </NavLink>
        </>
      )}
    </>
  );

  return (
    <div className="app-shell">
      {/* Desktop sidebar */}
      <aside className="sidebar">
        <NavLink to="/" className="sidebar-logo" onClick={closeMenu}>
          <div className="sidebar-logo-mark"><Icon size={38} /></div>
          <div className="sidebar-logo-text">
            <span className="sidebar-logo-name">SUFC SECURE<br />TRANSFER SYSTEM</span>
          </div>
        </NavLink>
        <nav className="sidebar-nav"><NavItems /></nav>
        <div className="sidebar-footer">
          <div className="sidebar-user">
            <div className="sidebar-avatar">{initials}</div>
            <div className="sidebar-user-info">
              <div className="sidebar-user-name">{user?.name || user?.email || 'User'}</div>
              <div className="sidebar-user-role">{isAdmin ? 'Administrator' : 'Staff'}</div>
            </div>
          </div>
          <button className="sidebar-logout" onClick={onLogout} title="Sign out">⏻</button>
        </div>
      </aside>

      {/* Mobile overlay */}
      {menuOpen && <div className="mobile-overlay" onClick={closeMenu} />}

      {/* Mobile drawer */}
      <aside className={`sidebar mobile-drawer${menuOpen ? ' open' : ''}`}>
        <NavLink to="/" className="sidebar-logo" onClick={closeMenu}>
          <div className="sidebar-logo-mark"><Icon size={38} /></div>
          <div className="sidebar-logo-text">
            <span className="sidebar-logo-name">SUFC SECURE<br />TRANSFER SYSTEM</span>
          </div>
        </NavLink>
        <nav className="sidebar-nav"><NavItems /></nav>
        <div className="sidebar-footer">
          <div className="sidebar-user">
            <div className="sidebar-avatar">{initials}</div>
            <div className="sidebar-user-info">
              <div className="sidebar-user-name">{user?.name || user?.email || 'User'}</div>
              <div className="sidebar-user-role">{isAdmin ? 'Administrator' : 'Staff'}</div>
            </div>
          </div>
          <button className="sidebar-logout" onClick={onLogout} title="Sign out">⏻</button>
        </div>
      </aside>

      <main className="main-content">
        <div className="topbar mobile-only">
          <button className="mobile-menu-btn" onClick={() => setMenuOpen(o => !o)} aria-label="Menu">
            <span /><span /><span />
          </button>
        </div>
        <div className="page-content">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
